const ConversionTypes = {
    CostPer100g: 1,
    CostPer100ml: 2,
    CostPer1l: 3,
    CostPerUnit: 4
};

export default ConversionTypes;